import * as angular from "angular";
import ContactEditController from "./ContactEditController";

export default angular.module('app.customer.contact.edit', [])
    .component('customerContactEdit', {
        template: require('./ContactEdit.html'),
        controller: ContactEditController,
        controllerAs: 'vm',
        bindings: {
            resolve: '<',
            close: '&',
            dismiss: '&'
        },
    }).name;
